import script from "./show-matches.vue.ts?vue&type=script&setup=true&lang=ts!=!../../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./show-matches.vue?vue&type=script&setup=true&lang=ts"
export * from "./show-matches.vue.ts?vue&type=script&setup=true&lang=ts!=!../../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./show-matches.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__